module.exports = __webpack_public_path__ + "img/16.0f3f9da3.png";